module.exports = __webpack_public_path__ + "static/stonewood_manor-39984601e3c1b7e64016ea2286654527.jpg";